var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssessmentHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2745 3.96941C27.9123 3.61394 27.4232 3.40978 26.9102 3.39991H10.8524C10.591 3.39928 10.332 3.44928 10.0904 3.54702C9.8488 3.64477 9.62936 3.78832 9.44475 3.96941L5.68228 7.64991C5.49755 7.83078 5.35105 8.04548 5.25115 8.28175C5.15126 8.51802 5.09993 8.77123 5.1001 9.02691V28.6534C5.09997 29.1624 5.30364 29.6511 5.66747 30.015C6.03129 30.3788 6.52633 30.5888 7.0465 30.5999H26.9102C27.438 30.5999 27.9441 30.3948 28.3173 30.0298C28.6905 29.6647 28.9001 29.1696 28.9001 28.6534V5.34641C28.8951 5.08765 28.8372 4.83249 28.7297 4.59599C28.6222 4.35949 28.4675 4.14644 28.2745 3.96941ZM13.0074 24.7689H11.0175V22.8309H13.0074V24.7689ZM13.0074 18.9379H11.0175V16.9999H13.0074V18.9379ZM12.6337 14.2034C12.5416 14.2944 12.432 14.3666 12.3112 14.4159C12.1904 14.4652 12.0608 14.4905 11.9299 14.4905C11.799 14.4905 11.6694 14.4652 11.5486 14.4159C11.4278 14.3666 11.3182 14.2944 11.2261 14.2034L9.3231 12.3674L10.7308 10.9904L11.9038 12.1379L14.0153 10.0724L15.423 11.4494L12.6337 14.2034ZM23.9298 24.7689H16.9784V22.8309H23.9298V24.7689ZM23.9298 18.9379H16.9784V16.9999H23.9298V18.9379ZM23.9298 13.1069H16.9784V11.1689H23.9298V13.1069Z",
    fill: "#95A4C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessmentHover);
export default __webpack_public_path__ + "static/media/assessmentHover.9081b9709735bd1c1c66a0adf72d9fd9.svg";
export { ForwardRef as ReactComponent };